export default "__VITE_ASSET__D$B4OX3F__"